module.exports = __webpack_public_path__ + "assets/img/e4.4b47eb0e.jpg";